import { TAdminCreatePayload } from '@mybonum/api';

import { TAdminFormValues } from '../components/form';

import { convertRoleToEnum } from './convert-role.ts';

export const normalizeToApi = (values: TAdminFormValues): TAdminCreatePayload => {
    return {
        email: values.email,
        role: convertRoleToEnum(values.role),
    };
};
